document.addEventListener('DOMContentLoaded', function () {
  var bar = document.getElementById('VvStickyAtc');
  if (!bar) return;

  var priceEl = document.getElementById('VvStickyAtcPrice');
  var variantSel = document.getElementById('VvStickyAtcVariant');
  var qtyInput = document.getElementById('VvStickyAtcQty');
  var button = document.getElementById('VvStickyAtcButton');

  // Mapa de variantes (preco formatado + disponibilidade), vindo do JSON embutido.
  var vmap = {};
  var dataEl = document.getElementById('VvStickyAtcData');
  if (dataEl) {
    try {
      var data = JSON.parse(dataEl.textContent);
      (data.variants || []).forEach(function (v) {
        vmap[String(v.id)] = v;
      });
    } catch (e) {}
  }

  function currentVariantId() {
    if (variantSel) return variantSel.value;
    return bar.getAttribute('data-default-variant');
  }

  // Atualiza preco e estado do botao conforme a variante selecionada na barra.
  function applyVariantState() {
    var v = vmap[String(currentVariantId())];
    if (!v) return;
    if (priceEl && v.price) priceEl.textContent = v.price;
    if (button) {
      if (v.available === false) {
        button.disabled = true;
        button.textContent = 'Esgotado';
      } else {
        button.disabled = false;
        button.textContent = 'Comprar';
      }
    }
  }

  // Seletor de quantidade.
  bar.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (b.getAttribute('data-qty') === 'plus') {
        val += 1;
      } else {
        val = Math.max(1, val - 1);
      }
      qtyInput.value = val;
    });
  });

  if (variantSel) {
    variantSel.addEventListener('change', applyVariantState);
  }
  applyVariantState();

  // Add-to-cart espelhando EXATAMENTE o product-form.js do Dawn (FormData com id +
  // quantity + sections + sections_url, Accept application/javascript). Assim o
  // cart.renderContents(response) reconstroi o drawer igual ao fluxo nativo,
  // incluindo o BLOCO DE ITENS. (Enviar como JSON items:[] retornava um formato de
  // resposta diferente e o bloco de itens nao renderizava.)
  if (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();

      var v = vmap[String(currentVariantId())];
      if (button.disabled || (v && v.available === false)) return;

      var id = currentVariantId();
      if (!id) return;
      var qty = parseInt(qtyInput.value, 10) || 1;

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      var formData = new FormData();
      formData.append('id', id);
      formData.append('quantity', qty);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }

      var original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adicionando...';

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            button.disabled = false;
            button.textContent = original;
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          } else {
            window.location = window.routes.cart_url;
            return;
          }
          button.disabled = false;
          button.textContent = 'Comprar';
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = original;
        });
    });
  }

  // Sync melhor-esforco: se o cliente escolher a variante NA PAGINA, reflete na barra.
  if (variantSel) {
    var form = document.getElementById('product-form-main');
    if (form) {
      var pageIdInput = form.querySelector('[name="id"]');
      var syncFromPage = function () {
        if (!pageIdInput) return;
        var pageId = String(pageIdInput.value || '');
        if (pageId && variantSel.value !== pageId && vmap[pageId]) {
          variantSel.value = pageId;
          applyVariantState();
        }
      };
      form.addEventListener('change', function () {
        window.setTimeout(syncFromPage, 60);
      });
    }
  }
});
